<template>
  <div class="service-high-flow-alarm">
    <p>
      {{ $t('messages.alarms.serviceHighFlowAlarm.description') }}
    </p>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <flow-gauge-component :store = "store" />

    <alert-handler-list
      class="g-alarm-handler__row"
      :list="alarmData.list"
    />

    <!-- <div class="g-alarm-handler__row">
      <h3 class="g-text g-text--center">
        {{ $t('messages.alarms.suggestion') }}
      </h3>
      <p>
        {{ $t('messages.alarms.serviceHighFlowAlarm.suggestion') }}
      </p>
    </div> -->

    <div class="g-text g-text--center">
      <selective-survey-button :list="alarmData.list" />
    </div>
  </div>
</template>


<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'
import FlowGauge from '@/components/FlowGauge.vue'
import ServiceSelectiveSurveyButton from '@/components/elements/ServiceSelectiveSurveyButton'

export default {
  name: 'ServiceHighFlowAlarm',
  components: {
    'flow-gauge-component': FlowGauge,
    'selective-survey-button': ServiceSelectiveSurveyButton
  },
  mixins: [ServiceAlarm],
  data() {
    return {
    }
  }
}
</script>

<style lang="scss">
.service-high-flow-alarm {
  .flow-content-text--blue {
    color: $color-red-error;
  }
  .flow-wrapper {
     margin-top: 16px; // flow already has 4px padding
  }
}
</style>